import { render, staticRenderFns } from "./kmodal.vue?vue&type=template&id=a811e404&scoped=true&"
import script from "./kmodal.vue?vue&type=script&lang=js&"
export * from "./kmodal.vue?vue&type=script&lang=js&"
import style0 from "./kmodal.vue?vue&type=style&index=0&id=a811e404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a811e404",
  null
  
)

export default component.exports